// extracted by mini-css-extract-plugin
module.exports = {"formChoice":"choicePage_formChoice__1bX_p","ButtonWrapper":"choicePage_ButtonWrapper__2_fhh","buttonChoice":"choicePage_buttonChoice__3_qw2"};